import type { Brand as BaseBrand } from '../../../types';

// Extend the Brand interface to include social_accounts
interface SocialAccount {
  accountId: string;
  platform: string;
  pageId: string;
  username?: string;
  profileImage?: string;
  picture_url?: string;
  followers_count?: number; // Ajout du nombre de followers depuis l'API
  name?: string; // Nom d'affichage du compte
  is_verified?: boolean; // Statut de vérification
}

export interface Brand extends BaseBrand {
  social_accounts?: SocialAccount[];
}

// Fonction utilitaire pour récupérer le nombre de followers d'un compte spécifique
export const getFollowersCount = (brand: Brand | undefined, platform: string): number | null => {
  if (!brand?.social_accounts) return null;
  
  const account = brand.social_accounts.find(
    acc => acc.platform.toLowerCase() === platform.toLowerCase()
  );
  
  return account?.followers_count || null;
};

// Fonction utilitaire pour formater le nombre de followers
export const formatFollowersCount = (count: number | null): string => {
  if (count === null || count === undefined) return '0';
  
  if (count >= 1000000) {
    return `${(count / 1000000).toFixed(1)}M`;
  } else if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}K`;
  } else {
    return count.toLocaleString();
  }
};

export interface PreviewProps {
  content: string;
  brand?: Brand;
  brandName?: string;
  brandLogo?: string;
  mediaUrl?: string;
  mediaUrls?: string[]; // multi-images support
  format?: 'regular' | 'reel';
  hideEngagementCounts?: boolean;
  engagement?: {
    likes: number;
    comments: number;
    shares: number;
    views: number;
  };
}

// Update LightPreviewProps to correctly extend PreviewProps
export interface LightPreviewProps {
  content: string;
  brand?: Brand;
  brandName?: string;
  brandLogo?: string;
  mediaUrl?: string | { src: string };
  format?: 'regular' | 'reel';
}